module.exports = __webpack_public_path__ + "img/heart.ae62b9db.svg";